export default "__VITE_ASSET__9ed6bfdc__"